const EXAMPLES = [
  'A React dashboard for tracking tasks',
  'Go CLI to parse and validate config files',
  'Python Flask API for a recipe app',
  'Rust CLI to batch resize images',
  'Full-stack blog with authentication',
]

interface ExamplePromptsProps {
  onSelect: (prompt: string) => void
}

export function ExamplePrompts({ onSelect }: ExamplePromptsProps) {
  return (
    <div className="flex flex-wrap gap-2 justify-center mt-4 px-4">
      {EXAMPLES.map((example) => (
        <button
          key={example}
          onClick={() => onSelect(example)}
          className="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
        >
          {example}
        </button>
      ))}
    </div>
  )
}
